import '../sass/timeline.scss';

(() => {
    const $blocks = document.querySelectorAll('.timeline-text');

    $blocks?.forEach($block => {
        const $timelineItinerary = document.querySelector(`#${$block?.dataset?.timelineItineraryId}`);
        const $buttonRacing = $block.querySelector('.timeline-text__button--racing');
        const $buttonShowAll = $block.querySelector('.timeline-text__button--show-all');
        const $events = $timelineItinerary.querySelectorAll('.timeline-itinerary__event');

        const filterTimeline = showAll => {
            const url = new URL(window.location.href);
            const searchParams = url.searchParams;

            if ($events) {
                $events.forEach($event => {
                    $event.classList.remove('is-on-screen');
                });
            }

            if (showAll) {
                searchParams.set('timeline-filter', 'all');
            } else {
                searchParams.delete('timeline-filter');
            }

            window.history.replaceState('', '', url.toString());

            $timelineItinerary.classList.remove('timeline-itinerary--show-all');

            if (!showAll) {
                $buttonRacing.classList.add('button--solid');

                if ($buttonRacing) {
                    $buttonShowAll.classList.remove('button--solid');
                }
            }

            if (showAll) {
                $timelineItinerary.classList.add('timeline-itinerary--show-all');

                $buttonShowAll.classList.add('button--solid');

                if ($buttonRacing) {
                    $buttonRacing.classList.remove('button--solid');
                }
            }

            const $groupStarter = $timelineItinerary.querySelector('.timeline-itinerary__group--starting');

            $groupStarter.classList.remove('timeline-itinerary__group--starting');

            const $groups = $timelineItinerary.querySelectorAll(showAll ? '.timeline-itinerary__group' : '.timeline-itinerary__group--race');

            if ($groups) {
                $groups[0].classList.add('timeline-itinerary__group--starting');
                $groups[$groups.length - 1].classList.add('timeline-itinerary__group--ending');
            }

            window.checkOnScreenEls();
        }

        const initButtons = () => {
            if ($buttonRacing) {
                $buttonRacing.addEventListener('click', () => {
                    filterTimeline(false);
                });
            }

            if ($buttonShowAll) {
                $buttonShowAll.addEventListener('click', () => {
                    filterTimeline(true);
                });
            }
        };

        const url = new URL(window.location.href);
        const searchParams = url.searchParams;

        initButtons();
        filterTimeline(searchParams.get('timeline-filter') === 'all');
    });
})();
